/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste or type your text here…`)
};

const es_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega o escribe tu texto aquí…`)
};

const de_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie hier Ihren Text ein oder geben Sie ihn ein…`)
};

const nl_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak of typ uw tekst hier…`)
};

const fr_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez ou tapez votre texte ici…`)
};

const it_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla o digita il tuo testo qui…`)
};

const pt_br2_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole ou digite seu texto aqui…`)
};

const pt_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole ou escreva aqui o seu texto…`)
};

const ja_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここにテキストを貼り付けるか入力してください…`)
};

const zh_wc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在此粘贴或输入文本……`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_placeholder", locale)
	if (locale === "en") return en_wc_placeholder(inputs)
	if (locale === "es") return es_wc_placeholder(inputs)
	if (locale === "de") return de_wc_placeholder(inputs)
	if (locale === "nl") return nl_wc_placeholder(inputs)
	if (locale === "fr") return fr_wc_placeholder(inputs)
	if (locale === "it") return it_wc_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_wc_placeholder(inputs)
	if (locale === "pt") return pt_wc_placeholder(inputs)
	if (locale === "ja") return ja_wc_placeholder(inputs)
	return zh_wc_placeholder(inputs)
};